import { Component, Input, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { TranslationGeneralService } from '../../../../shared/translation/translation.general.service';
import { CalendarScopeKind, ICalService } from '../ical.service';

/**
 * The entries of the add-to-calendar menu - Google Calendar, Outlook, .ics - kept in one place
 * (workorder-calendar-quick-wins-a2-action-bar-2026-11-02, task 2). Whoever shows the menu uses the exported
 * `menu` as `[matMenuTriggerFor]`: the button of the vote response page, the calendar icon of the context action
 * bar and its kebab sub menu. The triggers call `ICalService.prepareAccessLink()` on `menuOpened`, so Google and
 * Outlook open synchronously in the click (popup blocker).
 */
@Component({
    selector: 'add-to-calendar-menu-items',
    exportAs: 'calendarMenuItems',
    standalone: true,
    imports: [
        MatIconModule,
        MatMenuModule,
    ],
    templateUrl: './add-to-calendar-menu-items.component.html',
})
export class AddToCalendarMenuItemsComponent {
    @Input() scope: CalendarScopeKind = 'votedFor';
    @ViewChild(MatMenu, { static: true }) menu: MatMenu;

    constructor(
        public iCal: ICalService,
        public trans: TranslationGeneralService,
    ) { }
}
